import AppRoutePath from "../../../../../router/AppRoutePath";

export const paymentType = [
  { label: "Installment", value: "installment" },
  // { label: "Balloon Payment", value: "balloon_payment" },
];

export const tenorType = [
  { label: "Reguler", value: "reguler" },
  // { label: "Non Regular", value: "non_reguler" },
];

export const pawnType = [
  { label: "Reguler", value: "reguler" },
  { label: "Jemput Gadai", value: "pick_up" },
];

export const dataBreadcrumb = [
  { label: "Reguler Offer", route: AppRoutePath.CAMPAIGN },
  { label: "Pinjaman Cicilan", route: AppRoutePath.CAMPAIGN },
  { label: "Tambah Reguler Offer Pinjaman Cicilan", route: null },
];

export const dataBreadcrumbEdit = [
  { label: "Reguler Offer", route: AppRoutePath.CAMPAIGN },
  { label: "Pinjaman Cicilan", route: AppRoutePath.CAMPAIGN },
  { label: "Ubah Reguler Offer Pinjaman Cicilan", route: null },
];

export const chargeTime = [
  { label: "Bayar di Depan", value: "front" },
  { label: "Bayar di Akhir", value: "behind" },
  { label: "Bayar di Akhir V2", value: "behind_new" },
];

export const initChargeTime = {
  capitalLoan: 'front',
  feeAdmin: 'front',
  feeSavingInsurance: 'front',
  feeInsurance: 'front',
}
